<script>
  export let isActive
  export let onClick
</script>

<style>
  svg {
    width: 30px;
    margin-left: 10px;
    fill: #6e6e6e;
    cursor: pointer;
    border: 1px solid transparent;
  }
  .isActive {
    fill: white;
    border-color: white;
    border-radius: 4px;
  }
</style>

<svg class:isActive xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" on:click={onClick}>
  <g id="regular-expression">
    <path id="upper-case" d="M7.53 7L4 17h2.063l.72-2.406h3.624l.72 2.406h2.062L9.65 7h-2.12zm1.064 1.53L9.938 13H7.25l1.344-4.47z" />
    <path
      id="lower-case"
      d="M18.55 17l-.184-1.035h-.055c-.35.44-.71.747-1.08.92-.37.167-.85.25-1.44.25-.564 0-.955-.208-1.377-.625-.42-.418-.627-1.012-.627-1.784 0-.808.283-1.403.846-1.784.568-.386 1.193-.607 2.208-.64l1.322-.04v-.335c0-.772-.396-1.158-1.187-1.158-.61 0-1.325.18-2.147.55l-.688-1.4c.877-.46 1.85-.69 2.916-.69 1.024 0 1.59.22 2.134.662.545.445.818 1.12.818 2.03V17h-1.45m-.394-3.527l-.802.027c-.604.018-1.054.127-1.35.327-.294.2-.442.504-.442.912 0 .58.336.87 1.008.87.48 0 .865-.137 1.152-.414.29-.277.436-.645.436-1.103v-.627" />
  </g>
</svg>
